import { render, staticRenderFns } from "./CareNew.vue?vue&type=template&id=39bee991&scoped=true&"
import script from "./CareNew.vue?vue&type=script&lang=js&"
export * from "./CareNew.vue?vue&type=script&lang=js&"
import style0 from "./CareNew.vue?vue&type=style&index=0&id=39bee991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bee991",
  null
  
)

export default component.exports